import { render, staticRenderFns } from "./headWap.vue?vue&type=template&id=f50603b6&scoped=true&"
import script from "./headWap.vue?vue&type=script&lang=js&"
export * from "./headWap.vue?vue&type=script&lang=js&"
import style0 from "./headWap.vue?vue&type=style&index=0&id=f50603b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50603b6",
  null
  
)

export default component.exports